import type { Regie } from '@mairistem/comptabilite';
import type { TemplateRequestGet } from '@mairistem/finances-utils';
import { request } from '@mairistem/tools';

export const getRegies = () =>
	request.get<unknown, TemplateRequestGet<Regie>>(
		'/api/finances/comptabilite/piecescomptables/regies?all',
	);

export default getRegies;
